import React from 'react';
import { Chip, Typography } from '@scale/scaleui';
import SAlert from 'react-s-alert';

const ClickableCopyToClipboardChip = (text: string) => {
  const variable = `{{${text}}}`;
  return (
    <Chip
      className="p-1"
      label={variable}
      onClick={() => {
        navigator.clipboard.writeText(variable);
        SAlert.success(`Copied to "${variable}" to clipboard`);
      }}
    />
  );
};

const SmsVariablesList = ({ availableVariables }: { availableVariables: string[] }) => {
  return (
    <div className="flex items-center">
      <Typography.Paragraph2 className="text-neutral-600 inline-block mr-2">
        Available variables
      </Typography.Paragraph2>

      <div className="flex flex-row gap-1 flex-wrap">
        {availableVariables.map(header => ClickableCopyToClipboardChip(header))}
      </div>
    </div>
  );
};

export default SmsVariablesList;
